import React from 'react'

const About = () => {
  return (
    <section className='sction about-section'>
      <h1 className='section-title'>about us</h1>
      <p>This has been one of the busiest and most amazing months in Splinterlands history and we have so much to share with you today! We’ll do our best to keep things brief, but remember you can always visit the linked blog posts for more in depth details about each topic.</p>
    </section>
  )
}

export default About;